export default {
  setView(state, payload) {
    state.profitView = payload.value;
  },
  increaseTimer(state) {
    state.timer++;
  },
  resetTimer(state) {
    state.timer = 0;
  },
  setTimeUnits(state, payload) {
    state.timeUnits = payload.units;
  },
  setCurrency(state, payload) {
    state.selectedCurrency = payload.currency;
  },
  setSortCategory(state, payload) {
    switch(payload.category) {
      case 'Earnings Hi/Lo':
        state.sortCategory="annualEarnings";
        state.sortDirection=1;
      break;
      case 'Earnings Lo/Hi':
        state.sortCategory="annualEarnings";
        state.sortDirection=-1;
      break;
      case 'Team Name':
        state.sortCategory="team";
        state.sortDirection=1;
      break;
      case 'Previous Rank':
        state.sortCategory="prevRank";
        state.sortDirection=-1;
      break;
      case 'Country':
        state.sortCategory="country";
        state.sortDirection=1;
      break;
      default:
        state.sortCategory="annualEarnings";
        state.sortDirection=1;
    }
  },
};
